export default __webpack_public_path__ + "static/media/avatar-default-community.8ca76e56.png";